import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";

import {
  LoadingDiv,
  SweetAlertShow,
} from "../master/Master";

import {
  collectionDistributionItemsList,
  collectionDistributionItemFieldsList,
  collectionDistributionEntryAdd,
} from "../../api/CollectionDistribution";

export default function CommonEntry({
  type = "Collection",
}) {

  const [searchParams] = useSearchParams();

  const item_id = searchParams.get("item_id");

  const [loading, setLoading] = useState(false);

  const [items, setItems] = useState([]);

  const [fields, setFields] = useState([]);

  const [selectedItem, setSelectedItem] =
    useState(item_id || "");

  const [itemData, setItemData] =
    useState({});

  const getItems = async () => {

    try {

      const response =
        await collectionDistributionItemsList();

      if (response?.data?.status) {

        setItems(response?.data?.data || []);

        if (item_id) {

          const findItem =
            response?.data?.data?.find(
              (x) => x?.id == item_id
            );

          setItemData(findItem || {});
        }
      }

    } catch (error) {}
  };

  const getFields = async (id) => {

    if (!id) return;

    setLoading(true);

    try {

      const response =
        await collectionDistributionItemFieldsList({
          item_id: id,
        });

      if (response?.data?.status) {

        setFields(response?.data?.data || []);
      }

    } catch (error) {

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ||
          error?.message
      );

    } finally {

      setLoading(false);
    }
  };

  const handleItemChange = (e) => {

    const id = e.target.value;

    setSelectedItem(id);

    const findItem = items?.find(
      (x) => x?.id == id
    );

    setItemData(findItem || {});

    getFields(id);
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      const formData = new FormData(e.target);

      formData.append("item_id", selectedItem);

      formData.append("entry_type", type);

      const response =
        await collectionDistributionEntryAdd(
          formData
        );

      if (response?.data?.status) {

        SweetAlertShow(
          "success",
          "Success",
          response?.data?.message
        );

        e.target.reset();

      } else {

        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }

    } catch (error) {

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ||
          error?.message
      );

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {

    getItems();

    if (item_id) {
      getFields(item_id);
    }

  }, []);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">

        <div className="layout-container">

          <Header />

          <div className="layout-page">

            <Nav />

            <div className="content-wrapper">

              <div className="container-fluid mt-3">

                <div className="row">

                  <Master />

                  <div className="col-md-10">

                    <div className="card">

                      <div className="card-body">

                        <h4 className="text-primary mb-4">
                          {type} Entry
                        </h4>

                        <form onSubmit={handleSubmit}>

                          <div className="row">

                            <div className="col-md-6 mb-3">

                              <label className="form-label">
                                Select Item
                              </label>

                              <select
                                className="form-select"
                                value={selectedItem}
                                onChange={
                                  handleItemChange
                                }
                                required
                              >
                                <option value="">
                                  Select Item
                                </option>

                                {items?.map((item) => (

                                  <option
                                    value={item?.id}
                                    key={item?.id}
                                  >
                                    {item?.item_name}
                                  </option>

                                ))}
                              </select>

                            </div>

                            <div className="col-md-6 mb-3">

                              <label className="form-label">
                                Quantity
                              </label>

                              <input
                                type="number"
                                className="form-control"
                                name="quantity"
                                defaultValue={1}
                              />

                            </div>

                            {fields?.map((field) => (

                              <div
                                className="col-md-6 mb-3"
                                key={field?.id}
                              >

                                <label className="form-label">
                                  {
                                    field?.field_label
                                  }
                                </label>

                                {field?.field_type ===
                                  "text" && (
                                  <input
                                    type="text"
                                    className="form-control"
                                    name={
                                      field?.field_name
                                    }
                                  />
                                )}

                                {field?.field_type ===
                                  "number" && (
                                  <input
                                    type="number"
                                    className="form-control"
                                    name={
                                      field?.field_name
                                    }
                                  />
                                )}

                                {field?.field_type ===
                                  "date" && (
                                  <input
                                    type="date"
                                    className="form-control"
                                    name={
                                      field?.field_name
                                    }
                                  />
                                )}

                                {field?.field_type ===
                                  "textarea" && (
                                  <textarea
                                    className="form-control"
                                    rows={3}
                                    name={
                                      field?.field_name
                                    }
                                  />
                                )}

                              </div>

                            ))}

                            <div className="col-md-12">

                              <button
                                type="submit"
                                className="btn btn-primary"
                              >
                                Submit {type}
                              </button>

                            </div>

                          </div>

                        </form>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
    </>
  );
}